import { AnyObject } from 'typings/custom'

const colorCodes = {
  white: '#FFFFFF',
  whiteSmoke: '#F6F6F6',
  black: '#000000',
  lightBlack: '#333333',
  darkBlack: '#2e3942',
  yellow: '#f3ce3d',
  greyFive: '#F9FBFC',
  greyTen: '#F6F8FA',
  greyTwenty: '#F2F5F8',
  greyThirty: '#E2E7EC',
  greyThirtyTwo: '#9299a0',
  greyForty: '#BEC5CC',
  greyFifty: '#93999F',
  greySixty: '#595B53',
  greyEighty: '#303941',
  greyEightySix: '#dbdbdb',
  greyEightyEight: '#e0e0e0',
  greyNinetyEight: '#fafafa',
  darkGrey: '#656565',
  silverGrey: '#9e9e9e',
  brightGrey: '#595b5e',
  confirm: '#3E8529',
  info: '#34657f',
  infoAlt: '#4b7f99',
  warning: '#F8D554',
  error: '#c63527',
  errorAlt: '#db6262',
  errorAltLight: '#fff2f1',
  link: '#014990',
  active: '#2c7ed0',
  turtleGreen: '#6db359',
  fernGreen: '#4e803f',
  lightGreen: '#e1f0dd',
  pooBrown: '#886303',
  pale: '#fff3ce',
  mariGold: '#ffc800',
  darkBlue: '#1565b5',
  darkBlueGrey: '#1e2549',
  cyanBlue: '#0072ad',
  darkCoral: '#c84e4e',
  iceBlue: '#ecf0f5',
  aliceBlue: '#f1f5f8',
  azure: '#15b6e5',
  bluish: '#cadff3',
  cobalt: '#004895',
  cloudyBlue: '#bbcdd4',
  brownishYellow: '#cba401',
  accent: '#1c3a47',
  davysGrey: '#575c5e',
  // WHY is this named pink? This is pure gray
  veryLightPink: '#ededed',
  datepickerSelectedDayHover: '#f0f0f0'
}

export type ColorsTypes = keyof typeof colorCodes | ''

export const colors: AnyObject = colorCodes

export const opacities = {
  greyFiftyOne: 'rgba(48, 57, 65, 0.51)',
  greyEightyTwo: 'rgba(48, 57, 65, 0.2)',
  greyEightyOne: 'rgba(48, 57, 65, 0.1)',
  whiteTwentyFive: 'rgba(0, 0, 0, 0.25)',
  lightBlack: 'rgba(0, 0, 0, 0.2)'
}
